import moment from "moment";
import { getRefreshTokenInfo, clearStorage } from "@/utils/localStorageUtils";

export default {
  data() {
    return {
      refreshTokenExpireAt: ""
    };
  },
  mounted() {
    if (getRefreshTokenInfo()) {
      ({
        refresh_token_expires_at: this.refreshTokenExpireAt
      } = getRefreshTokenInfo());
    }
  },
  computed: {
    accessTokenExpiresAt() {
      return this.$store.getters.getAccessTokenExpiresAt;
    },
    accessToken() {
      return this.$store.getters.getAccessToken;
    }
  },
  methods: {
    $_checkTokenExpiration() {
      // Check whether refresh token expiration time is one minute before actual time
      const isRefreshTokenExpired = moment(this.refreshTokenExpireAt)
        .add(-1, "minutes")
        .isBefore(moment());
      // Check whether token expiration time is one minute before actual time
      const isAccessTokenExpired = moment(this.accessTokenExpiresAt)
        .add(-1, "minutes")
        .isBefore(moment());
      if (isRefreshTokenExpired) {
        this.$store.commit("logout");
        clearStorage();
        this.$router.push({ name: "prihlaseni" });
      } else if (isAccessTokenExpired || !this.accessToken) {
        return this.$store.dispatch("fetchFreshToken");
      } else {
        return Promise.resolve();
      }
    }
  }
};
